var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebookIconShare(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 11 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.77 10.3l.498-3.185H7.156V5.048c0-.872.435-1.721 1.829-1.721H10.4V.615S9.116.4 7.888.4C5.325.4 3.649 1.925 3.649 4.687v2.428H.8V10.3h2.85V18h3.507v-7.7H9.77z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIconShare);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTEiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxMSAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkuNzcwNzEgMTAuMjk5OUwxMC4yNjg1IDcuMTE0NzJINy4xNTU5M1Y1LjA0Nzc1QzcuMTU1OTMgNC4xNzYzNCA3LjU5MDczIDMuMzI2OTMgOC45ODQ3NyAzLjMyNjkzSDEwLjM5OThWMC42MTUwOUMxMC4zOTk4IDAuNjE1MDkgOS4xMTU3IDAuMzk5OTAyIDcuODg3OTUgMC4zOTk5MDJDNS4zMjQ2NCAwLjM5OTkwMiAzLjY0OTE0IDEuOTI1NDYgMy42NDkxNCA0LjY4NzE1VjcuMTE0NzJIMC43OTk4MDVWMTAuMjk5OUgzLjY0OTE0VjE3Ljk5OTlINy4xNTU5M1YxMC4yOTk5SDkuNzcwNzFaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };